<div class="dialogContainer">
  <div class="header">
    <h2>QEWL</h2>
  </div>
  @if (errorMessage()) {
    <div class="errorMessage">
      <pre>{{ errorMessage() }}</pre>
    </div>
  }
  <div class="downloadLink">
    <span class="spacer"></span>
    <button class="primary-button" matButton="filled" [disabled]="isBusy()" (click)="getMfgNumberExport()">Export Mfg Numbers
    </button>
  </div>
  @if (results && results.data.length == 0) {
    <div>
      <h3>No results found</h3>
    </div>
  }
  <div class="tableWrapper">
    <table mat-table class="qewl-table bordered-table" [dataSource]="results">
      <ng-container matColumnDef="check-box">
        <th class="checkboxCell" mat-header-cell *matHeaderCellDef>
          <mat-icon (click)="selectAll()">
            {{ allSelected() ? 'check_box' : 'check_box_outline_blank' }}
          </mat-icon>
        </th>
        <td class="centered-cell checkboxCell" mat-cell *matCellDef="let line;">
          <mat-icon [class.disabled]="disableCheckbox(line)">
            {{ line.selected && line.button.enabled ? 'check_box' : 'check_box_outline_blank' }}
          </mat-icon>
        </td>
      </ng-container>
      <ng-container matColumnDef="entity">
        <th mat-header-cell *matHeaderCellDef> Entity</th>
        <td mat-cell *matCellDef="let line"> {{ line.entityId }};{{ line.entityRevision }} -
          {{ line.lineNumber }}
        </td>
      </ng-container>
      <ng-container matColumnDef="line-amount">
        <th mat-header-cell *matHeaderCellDef> Line Amount</th>
        <td class="right-aligned" mat-cell *matCellDef="let line"> ${{ formatFloat(line.lineAmount, 2) }}</td>
      </ng-container>
      <ng-container matColumnDef="quantity">
        <th mat-header-cell *matHeaderCellDef> Quantity</th>
        <td class="centered-cell" mat-cell *matCellDef="let line"> {{ line.quantity }}</td>
      </ng-container>
      <ng-container matColumnDef="complexity">
        <th mat-header-cell *matHeaderCellDef> Complexity</th>
        <td class="centered-cell" mat-cell *matCellDef="let line"> {{ formatFloat(line.complexityScore, 2) }}</td>
      </ng-container>
      <ng-container matColumnDef="prn">
        <th class="prnCell" mat-header-cell *matHeaderCellDef> PRN</th>
        <td class="prnCell" mat-cell *matCellDef="let line" matTooltip="{{line.prn}}"
          matTooltipClass="non-truncating-tooltip">
          <span class="truncated">{{ line.prn }}</span>
        </td>
      </ng-container>
      <ng-container matColumnDef="controls">
        <th mat-header-cell *matHeaderCellDef></th>
        <td class="centered-cell" mat-cell *matCellDef="let line" (click)="$event.stopPropagation()">
          <button class="primary-button" matButton="text" [disabled]="!line.button.enabled"
            (click)="submitLine(line)">{{ line.button.message }}
          </button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let line; columns: displayedColumns" (click)="line.selected = selectLine(line)">
      </tr>
    </table>
  </div>
  <div class="buttonRow">
    <span class="spacer"></span>
    <button matButton="filled" [disabled]="isBusy()" class="dialogButton primary-button" (click)="submitSelected()">Send
      Selected To QEWL
    </button>
    <button matButton="filled" [disabled]="isBusy()" class="dialogButton warn-button" matDialogClose>Cancel</button>
  </div>
</div>
@if (isBusy()) {
  <div class="busyIndicator">
    <div class="busyContents">
      <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
      <label class="busyLabel">Please Wait...</label>
    </div>
  </div>
}
